import React, { useContext, useEffect, useState } from "react";
import LeftArrow from "../../img/Left_Arrow.svg";
import { useHistory } from "react-router-dom";
import { StyledPlatformLabel, StyledPlatformsIntContainer, StyledGoBack, StyledPlatformsSubtitle, Title, Button3, StyledPlatformsList, StyledToggleButtonRight, StyledToggleButtonLeft } from "./setup.style";
import axiosShopWrapper, {formDataWithToken, getHostname, wpUrl} from "../../services/globalService";
import FixelDataContext from "../../context/FixelDataContext";
import Firebase from "../../services/firebase"

const ConnectPlatforms = () => {
  const history = useHistory();

  const { fullFixelData, setFullFixelData } = useContext(FixelDataContext);

  const [platformsStatus, setPlatformsStatus] = useState({
    fb: true,
    ga: true,
    ms: false,
    pt: false,
  });

  const getPlatformStatus = () => {
    if (fullFixelData && fullFixelData.install_data && fullFixelData.install_data.options) {
      setPlatformsStatus(fullFixelData.install_data.options);
    }
  };

  useEffect(() => {
    getPlatformStatus();
  }, [fullFixelData]);

  const isPlatformActive = (platformName) => {
    return platformsStatus[platformName];
  };

  const handleToggleClick = (platformName, value) => {
    const newPlatformStatus = { ...platformsStatus };
    newPlatformStatus[platformName] = value;
    setPlatformsStatus(newPlatformStatus);
  };

  const toggleButton = (platformName) => {
    return (
      <div>
        <StyledToggleButtonLeft onClick={() => handleToggleClick(platformName, true)} value={isPlatformActive(platformName)}>
          On
        </StyledToggleButtonLeft>
        <StyledToggleButtonRight onClick={() => handleToggleClick(platformName, false)} value={!isPlatformActive(platformName)}>
          Off
        </StyledToggleButtonRight>
      </div>
    );
  };

  const modifyPlatforms = async () => {
    const newFullFixelData = { ...fullFixelData };
    try {
      const args = JSON.stringify({
          display: getHostname(window.location.hostname),
          email: Firebase.getCurrentUserMail(),
          "install_data" :{
            type: 'WORDPRESS',
            options: {...platformsStatus}
          }
      })
      const response = await formDataWithToken(wpUrl, {
        action: 'fxl_edit_platforms',
        data: args
      });

      console.log("modifyPlatforms res", response.data || response);
      newFullFixelData.install_data.options = platformsStatus;
      setFullFixelData(newFullFixelData);
      history.push("/setup");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <StyledPlatformsIntContainer>
      <StyledGoBack onClick={() => history.goBack()}>
        <img src={LeftArrow} alt="arrow left" /> Go Back
      </StyledGoBack>
      <Title align="left">Reach high value&nbsp;users, wherever&nbsp;they are</Title>
      <StyledPlatformsSubtitle>Fixel automagically integrates with your favorite ad platforms for creating high value audiences.</StyledPlatformsSubtitle>
      <StyledPlatformsList>
        <li>
          <StyledPlatformLabel>Facebook Ads</StyledPlatformLabel>
          {toggleButton("fb")}
        </li>
        <li>
          <StyledPlatformLabel>
            Google Analytics {"("}for Google Ads{")"}
          </StyledPlatformLabel>
          {toggleButton("ga")}
        </li>
        <li>
          <StyledPlatformLabel>Pinterest Ads</StyledPlatformLabel>
          {toggleButton("pt")}
        </li>
        <li>
          <StyledPlatformLabel>
            Microsoft Ads {"("}formerly Bing Ads{")"}
          </StyledPlatformLabel>
          {toggleButton("ms")}
        </li>
      </StyledPlatformsList>
      <Button3 onClick={modifyPlatforms}>Save</Button3>
    </StyledPlatformsIntContainer>
  );
};
export default ConnectPlatforms;
